<template>

  <header id="mainheader" class="app-header navbar ">
    <div class="flex flex-column col-12 p0 m0">
      <div id="reminderbarmain"  class="col-12 flex justify-center items-center hide xs-hide sm-hide alert alert-danger m0 p0" >
        <p class="m0">Vi kunne ikke behandle din sidste betaling.</p><p @click="openpaymentreminder()" class="semi-bold m0 pointer"> Opdater din betaling</p>
      </div>
      
      <div id="payproffnotification"  class="col-12 flex justify-center hide items-center payproffnotif highlights m0 p0"  >
        <p class="m0 p0 py1" >Verificer din <span class="semi-bold pointer" @click="gotoPayproff()">Payproff</span></p>
      </div>
      <div id="mainbarmobile" class="col-12 flex justify-start items-center md-hide lg-hide px0">
        <div class="pl2 flex-none">
          <a href="#/newsfeed" class="no-hover inline-block flex justify-start items-center">
            <img src="/static/svg/h.svg" alt="" height="24">
            <span class="h5 ml1 gibson darkblue mb0 semi-bold line-height-1">Håndværker.dk</span>
          </a>
        </div>
        <div class="flex flex-auto justify-end items-center pr2" style="height:inherit;">
          <div class="pr2 pointer mr1 relative" >
            <a href="#/messages/inbox"  class="primarycolor no-hover block">
              <span class="relative block" style="top:3px;">
                <span v-if="message !== 0" id="totalInbox" class='badge badge-pill badge-danger absolute' style="right:-10px;top:5px;">{{ message }}</span>
                <svg fill="currentColor" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"/><path d="M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"/><path d="M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"/></svg>
              </span>
            </a>
          </div>
          <button class="navbar-toggler sidebar-toggler primarycolor" type="button" @click="sidebarToggle">
            <svg fill="currentColor" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><path d="M76 24.6H7c-3.8 0.1-6.9-3.1-7-7 -0.1-3.9 3-7.1 6.8-7.2 0.1 0 0.1 0 0.2 0h69c3.8-0.1 6.9 3.1 7 7 0.1 3.9-3 7.1-6.8 7.2C76.1 24.6 76 24.6 76 24.6z"/><path d="M76 109.6H7c-3.8 0.1-6.9-3.1-7-7 -0.1-3.9 3-7.1 6.8-7.2 0.1 0 0.1 0 0.2 0h69c3.8-0.1 6.9 3.1 7 7 0.1 3.9-3 7.1-6.8 7.2C76.1 109.6 76 109.6 76 109.6z"/><path d="M114.5 67.1H5.5c-3 0-5.5-3.2-5.4-7.1 0-3.9 2.4-7.1 5.4-7.1h109c3 0 5.5 3.2 5.5 7.1C120 63.9 117.6 67.1 114.5 67.1 114.5 67.1 114.5 67.1 114.5 67.1z"/></svg>
          </button>
        </div>
      </div>

      <div id="mainbar" class="col-12 flex justify-between items-center xs-hide sm-hide">
        <div class="col-5 flex-none">
          <a href="#/newsfeed" class="no-hover inline-block flex justify-start items-center">
            <img src="/static/svg/h.svg" alt="" height="28" style="height: 28px!important;">
            <span class="h5 ml1 gibson darkblue mb0 semi-bold">Håndværker.dk</span>
          </a>
        </div>
        <div class="col-4 flex flex-auto justify-end items-center " style="height:inherit;">
          <div class="px2 pointer mr1 relative">
            <a href="#/messages/inbox" class="primarycolor no-hover block">
              <span class="relative block">
                <span v-if="message !== 0" id="totalInbox" class='badge badge-pill badge-danger absolute' style="right:-10px;top:5px;">{{ message }}</span>
                <svg fill="currentColor" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"/><path d="M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"/><path d="M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"/></svg>
              </span>
            </a>
          </div>
          <button class="navbar-toggler sidebar-toggler pl2" type="button" @click="sidebarToggle">
            <!-- image does not work anymore <img src="https://i.imgur.com/1Mcl50W.png" alt="" width="28" height="28" style="height: 28px!important;"> -->
            <span class="pb1">
              <svg viewBox="0 0 100 80" width="28" height="28">
                <rect width="100" height="12"></rect>
                <rect y="30" width="100" height="12"></rect>
                <rect y="60" width="100" height="12"></rect>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
    <b-modal class="p2" centered   v-model="modalShow" ok-only>
      <p class=" left-align darklblue regular line-height-4 mb2 p2">
        <br />
        Hej,
        <br />
        Husk at registrere dine telefonnumre inden mandag d. 16/11-2020
        <br /><br />
        Hos Håndværker.dk vil vi give dine kunder en tryg og sikker oplevelse. Derfor beder vi dig registrere, hvis dit firma bruger mere end ét telefonnummer. Det er en ekstra service til dine kunder, så de ved, når du ringer.
        <br /><br />
        <a href="#/ekstraphone" @click="modalShow = false" > Klik venligst her og indtast dine telefonnumre </a>


      </p>
    </b-modal>
    <paymentreminderpopup  @Nopaymentmethod="Nopaymentmethod" ref="paymentreminderpopup"></paymentreminderpopup>
  </header>
</template>
<script>
import paymentreminderpopup from './paymentreminderpopup'
export default {
  name: 'appHeader',
  components: {
    paymentreminderpopup
  },
  data () {
    return {
      partnerName: '',
      message: 0,
      chat: 0,
      modalShow: false,
      isSeen: false,
      nopaymentmethodbool: '',
      dashdata: ''
    }
  },
  created () {
    this.partnerName = localStorage.getItem('name')
    this.message = parseInt(localStorage.getItem('inbox'))
    this.dashdata = this.$route.query.dashdata
    var m = this
    if (!localStorage.getItem('ads9')) {
      setTimeout(function () {
        m.modalShow = false
      }, 1500)
      localStorage.setItem('ads9', 'true')
    }
  },
  mounted () {
    this.decode()
  },
  watch: {
    'nopaymentmethodbool': function (newVal, oldVal) {
      if (newVal === 'true') {
        this.Nopaymentmethod()
      }
      if (newVal === 'false') {
        this.$refs.paymentreminderpopup.hidemodalinitial()
        this.$refs.paymentreminderpopup.hidemodal()
        var reminderbar = document.getElementById('reminderbarmain')
        reminderbar.classList.add('hide')
        var bar = document.getElementById('mainbar')
        bar.style.marginTop = '0px'
      }
    }
  },
  methods: {
    decode () {
      console.log('window.location.hostname', window.location.hostname)
      if (window.location.hostname !== 'oldpartner.haandvaerker.dk') {
        var pid = localStorage.getItem('haaid')
        this.$http.get(this.$bitrixapi + 'helper/encode/' + pid, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              const query = Object.assign({}, this.$route.query)
              var allquery = ''
              Object.keys(query).forEach(querys => {
                console.log('querys', querys)
                allquery += '&' + querys + '=' + query[querys]
              })
              window.location.href = 'https://partner.haandvaerker.dk/#/login?code=' + res.data + allquery
            }
          },
          (response) => {
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        )
      }
    },
    Nopaymentmethod (method) {
      this.nopaymentmethodbool = method
      console.log('Nopaymentmethod', this.nopaymentmethodbool)
      if (this.nopaymentmethodbool === 'true') {
        this.openpaymentreminder()
      }
    },
    openpaymentreminder () {
      this.$refs.paymentreminderpopup.showmodalinitial()
      this.setwarning()
    },
    closebanner () {
      var checkpayproffbanner = document.getElementById('checkpayproffbanner')
      checkpayproffbanner.classList.add('hide')
      this.addorangepayproffbanner()
    },
    // nav methods
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
      document.body.classList.toggle('sidebar-mobile-show')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
      document.body.classList.toggle('sidebar-mobile-show')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    mailSupport () {
      this.$router.push('/skriv-tl-support')
    },
    gotoPayproff () {
      var m = this
      this.$router.push('/konto-update?dashdata=' + m.dashdata)
    },
    addorangepayproffbanner () {
      var payproffnotification = document.getElementById('payproffnotification')
      payproffnotification.classList.remove('hide')
    },
    setwarning () {
      if (this.nopaymentmethodbool) {
        var reminderbar = document.getElementById('reminderbarmain')
        reminderbar.style.marginTop = '0px'
        reminderbar.style.position = 'fixed'
        reminderbar.style.zIndex = '1026'
        reminderbar.classList.remove('hide')
        var navbar = document.getElementById('mainheader')
        navbar.style.borderBottom = '0px'
        navbar.style.position = 'none'
        navbar.classList.remove('navbar')
        navbar.classList.remove('app-header')
        var bar = document.getElementById('mainbar')
        bar.style.position = 'fixed'
        bar.style.zIndex = '1026'
        bar.style.backgroundColor = '#fff'
        bar.style.marginTop = '26px'
        bar.style.borderBottom = '1px solid #d1d4d7'
      }
    }
  }
}
</script>
<style>
@media (max-width: 991px) {
  .app-header.navbar .navbar-brand {
    margin: 0 auto!important;
    position: relative;
    left: 0;
  }
}
a:hover > span { color: rgba(0, 54, 69, 1.0); border: 0!important;}
.app-header.navbar .navbar-brand {
  margin: 0 auto;
}
@media (max-width: 320px) {
  .partnerName {
    position: absolute;
    right: 24px;
    top: 18px;
  }
}
.payproffnotif {
  background-color: #F2B500;
}
#payproffnotification {
    margin-top: 50px;
    position: fixed;
    z-index: 100;
    padding-left: 10px;
    padding-right: 10px;
    /* border: 1px solid; */
    /* margin-left: auto; */
}
.box-bottom-shadow {
-webkit-box-shadow: 0 8px 6px -6px rgb(255, 0, 0);
    -moz-box-shadow: 0 8px 6px -6px rgb(255, 0, 0);
        box-shadow: 0 8px 6px -6px rgb(255, 0, 0);
}
</style>



// WEBPACK FOOTER //
// Header.vue?43b067d4